module.exports = __webpack_public_path__ + "img/logo3.2085a1d3.jpg";